// extracted by mini-css-extract-plugin
module.exports = {"dom-container":"userPoints_dom-container_3vRpw"};